import { Alert, Box, Button, Checkbox, Chip, FormControlLabel, Grid, Paper, Typography } from "@mui/material";
import { FC } from "react";
import { documentList } from "../../pages/audit-admission-form/AuditAdmissionForm";
import "./RequiredDocuments.scss";

interface Props {
	requiredDocuments: string[];
	onChange: (requiredDocuments: string[]) => void;
}

const RequiredDocuments: FC<Props> = ({ requiredDocuments, onChange }) => {
	const toggleDocument = (document: string) => {
		onChange(requiredDocuments.includes(document)
			? requiredDocuments.filter(item => item !== document)
			: [...requiredDocuments, document]
		);
	};

	return (
		<Paper className="policy-card required-documents">
			<Box className="card-header">
				<Typography variant="h6">
					Documentos obrigatórios
				</Typography>
				<Chip
					label={`${requiredDocuments.length} de ${documentList.length}`}
					color={requiredDocuments.length ? "success" : "default"}
					size="small"
				/>
			</Box>
			<Typography variant="body2" color="text.secondary">
				Marque os documentos obrigatórios que o candidato precisa enviar para conseguir avançar no formulário de admissão.
			</Typography>
			<Box className="actions">
				<Button size="small" variant="outlined" onClick={() => onChange([...documentList])}>
					Marcar todos
				</Button>
				<Button size="small" variant="outlined" color="inherit" onClick={() => onChange([])}>
					Limpar seleção
				</Button>
			</Box>
			<Grid container>
				{documentList.map((document) => (
					<Grid item xs={12} sm={6} md={4} key={document}>
						<FormControlLabel
							className="document-option"
							control={
								<Checkbox
									checked={requiredDocuments.includes(document)}
									onChange={() => toggleDocument(document)}
								/>
							}
							label={document}
						/>
					</Grid>
				))}
			</Grid>
			{!requiredDocuments.length && <Alert severity="warning" className="info-box">
				Sem nenhum documento obrigatório o candidato avança enviando qualquer um dos documentos da lista.
			</Alert>}
		</Paper>
	);
};

export default RequiredDocuments;